import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M9.6 16.75c-.217 0-.433-.039-.637-.113a1.8 1.8 0 0 1-.588-.362L6.9 14.925Q4.175 12.5 2.088 10.187 0 7.877 0 5.15q0-2.2 1.496-3.675T5.225 0q1.28 0 2.415.538 1.135.537 1.96 1.537A6.2 6.2 0 0 1 11.592.537 5.4 5.4 0 0 1 13.967 0Q16.2 0 17.7 1.475t1.5 3.675q0 2.726-2.088 5.037-2.087 2.313-4.812 4.738l-1.475 1.35q-.275.25-.588.363-.312.111-.637.112m-.85-12.8q-.6-1.025-1.5-1.588A3.74 3.74 0 0 0 5.225 1.8q-1.467 0-2.446.95T1.8 5.16q0 1.265.9 2.665t2.15 2.738a35 35 0 0 0 2.575 2.487q1.324 1.15 2.175 1.9 1.084-.954 2.175-1.9a34 34 0 0 0 2.575-2.488 19.3 19.3 0 0 0 2.15-2.737q.9-1.4.9-2.665 0-1.46-.979-2.41t-2.446-.95a3.8 3.8 0 0 0-2.037.563q-.913.562-1.513 1.587a.78.78 0 0 1-.351.362q-.227.113-.475.113-.249 0-.487-.112a.77.77 0 0 1-.362-.363"
    }, null, -1)
  ]))]))
}
export default { render: render }